import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const PropertySummaryLoading = () => (
  <Box width="100%">
    <SkeletonLoader width={172} />
    <SkeletonLoader width={90} />
  </Box>
)
